import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { signInPage } from './SignInPage';
import { ssoCallbackPage } from './SsoCallbackPage';

export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage, ssoCallbackPage],
});
